import { Col, Container, Row } from "react-bootstrap";
import dataPlatformImg from "../../Assets/Projects/database.svg";
import llmProjectImg from "../../Assets/Projects/llm_chat.svg";
import marsRoverImg from "../../Assets/Projects/terminal.svg";
import orpimentImg from "../../Assets/Projects/cloud.svg";
import ParticlesBg from "../Background/ParticlesBg";
import ProjectCard from "./ProjectCards";

function Projects() {
  return (
    <Container fluid className="project-section home-section">
      {/* Background layer */}
      <ParticlesBg />

      {/* Foreground content layer - 添加这个包装 div！*/}
      <div
        style={{
          position: "relative",
          zIndex: 9999,
          pointerEvents: "auto",
        }}
      >
        <Container>
          <h1 className="project-heading">
            My Recent <strong className="purple">Work</strong>
          </h1>
          <p style={{ color: "white" }}>
            A selection of projects demonstrating my data engineering, AI and software engineering experience.
          </p>

          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            {/* 1. Data Engineering Project */}
            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={dataPlatformImg}
                isBlog={false}
                title="Data Engineering Mini Platform"
                description="An end-to-end data engineering platform covering SQL analytics, a FastAPI-based data service, and a serverless AWS Lambda pipeline writing scheduled API data to S3. Infrastructure is provisioned using Terraform and deployed via CI/CD with GitHub Actions."
                ghLink="https://github.com/Shyqwq5/Data-engineering-mini-platform"
              />
            </Col>

            {/* 2. Orpiment Group Project */}
            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={orpimentImg}
                isBlog={false}
                title="Orpiment ETL Data Warehouse"
                description="A comprehensive AWS-based ETL pipeline extracting data from PostgreSQL, transforming it into a star schema, and loading into a data warehouse. Built with Lambda Functions, Step Functions, and EventBridge scheduling, with infrastructure managed via Terraform and monitoring through CloudWatch."
                ghLink="https://github.com/izzycrouch/de-orpiment-group-project"
              />
            </Col>

            {/* 3. LLM / NLP Project */}
            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={llmProjectImg}
                isBlog={false}
                title="LLM-powered NLP Chatbot"
                description="An end-to-end NLP and machine learning pipeline combining a traditional text classifier with a large language model to deliver an interactive chatbot experience, including model training, inference and Retrieval-Augmented Generation (RAG)."
                ghLink="https://github.com/Shyqwq5/Natural-Language-Classifier-with-LLM-Enhanced-Chatbot"
              />
            </Col>

            {/* 4. Software Engineering Project */}
            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={marsRoverImg}
                isBlog={false}
                title="Mars Rover Interactive Simulator"
                description="A terminal-based Mars Rover simulator built in Python, allowing users to configure a plateau, land a rover and control its movement step by step via single-key commands, with a focus on clean architecture, input validation and testable logic."
                ghLink="https://github.com/Shyqwq5/Mars-Rover-Interactive-Simulator"
              />
            </Col>
          </Row>
        </Container>
      </div>
    </Container>
  );
}

export default Projects;